export default "__VITE_ASSET__CLzUnvKm__"